import React from 'react';

import { Status as StatusProps } from '../types';
import { ReactComponent as StatusErrorIcon } from '../assets/icons/status-error-icon.svg';
import { ReactComponent as ExitIcon } from '../assets/icons/exit-icon.svg';
import { ReactComponent as CheckIcon } from '../assets/icons/circle-check-icon.svg';

interface Props extends StatusProps {
  onExit: () => void;
  className?: string;
}

interface VariantProps {
  [key: string]: string;
}

const variantsStyles: VariantProps = {
  error: 'bg-[#D43700]',
  success: 'bg-[#009965]',
  warning: 'bg-[]'
};

const StatusError = (): React.ReactElement => <StatusErrorIcon className="mr-[13.5px]" />;
const StatusSuccess = (): React.ReactElement => <CheckIcon className="mr-[13.5px] fill-[#FFFFFF]" />;

const Status = ({ className, state, message, onExit }: Props): React.ReactElement => {
  // TODO: handle other status icon types when design is available
  const renderStatusIcon = (): React.ReactElement => {
    switch (state) {
      case 'error':
        return <StatusError />;
      case 'success':
        return <StatusSuccess />;
      default:
        return <StatusError />;
    }
  };

  return (
    <div
      className={`${className} fixed z-[100] left-0 top-0 w-full box-border py-[17px] px-[25px] text-white flex items-center justify-between shadow-statusShadow ${
        state && variantsStyles[state]
      }`}
    >
      <div className="flex items-center">
        {renderStatusIcon()}
        <p className="m-0 font-nunitoMedium text-[14px] tracking-[0.1px]">{message}</p>
      </div>
      <ExitIcon className="cursor-pointer fill-current text-white" onClick={onExit} />
    </div>
  );
};

export default Status;
